import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AppComponentClass } from '../../shared/service/AppComponent.class';
import { SummaryForm, Summary } from '../model/model.lead';
import { Option } from '../../shared/model/model.class';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SummaryService } from '../lead.service';
import { Router } from '@angular/router';
import { MatSnackBar, MatDialog } from '@angular/material';
//import { AlertComponent } from '../../shared/alert/alert.component';
import { AssignleadComponent } from '../assignlead/assignlead.component';
import { Theme } from '../../shared/service/AutoTheme';
//import { RestoreleadsComponent } from '../../shared/restoreleads/restoreleads.component';

@Component({
  selector: 'app-summary1',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent extends AppComponentClass<Summary, SummaryForm>
{
  keydata: number
  keytype: number = 0
  form: FormGroup
  public freeleads: number = 0
  public agentlead: any = []
  public allleads: number = 0
  public leadagentList: Option[]
  public setagent: number = 0
  public uploadlist = []
  public searchleads: string

  @Output() idclicktab = new EventEmitter();

  taLeads: number = 0
  BlankLeads: number = 0
  leadDialerList: any = []
  gTLeads: number = 0
  CampId: string;

  constructor(protected data: SummaryService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar, public dialog: MatDialog, private theme: Theme) {
    super(data, router, fb, msg);
    this.displayedColumns = [];
    this.keydata = parseInt(sessionStorage.getItem('userid'));
    this.keytype = parseInt(sessionStorage.getItem('type'));
      this.CampId = sessionStorage.getItem("currcampaign");
  }

  ngOnInit(): void {
    this.data.getOption('leadagent').subscribe(res => {
      console.log(res);
      this.leadagentList = res;
    });

    this.data.getService("batchfile", { id_campaign: this.CampId }).subscribe(res => {
      this.uploadlist = res;
    });

    // @summary lead counts
    this.getLeadCounts()

    // @dialer's lead counts
    this.getDialerLeadCounts()
  }

  getLeadCounts(): void {
    this.data.gettotallead().subscribe(res => {
      console.log(res);
      if (res != null) {
        // @count total leads
        this.freeleads = res[0].totallead

        // @count free leads
        this.allleads = res[0].allleads

        // @count free leads
        this.BlankLeads = res[0].blank_leads

        // @grand total leads
        this.gTLeads = this.allleads + this.BlankLeads

        this.getAssignLeadCounts()
      }
    })
  }

  getAssignLeadCounts(): void {
    this.data.GetAgentLead().subscribe(result => {
      console.log(result);
      this.agentlead = result;

      // @count assigned leads
      this.taLeads = 0
      for (let x of result) {
        this.taLeads += x.totalagntleads
      }

      // @calculate free leads
      this.freeleads = this.allleads != this.taLeads ? this.freeleads : 0
    })
  }

  getDialerLeadCounts(): void {
    if (this.campIds.length > 0) {
      let ccIds: any = []
      for (let x of this.campIds) {
        ccIds.push(x.id)
      }
      ccIds = ccIds.join()
      if (ccIds.length > 0) {
        this.data.GetDialerLeads(JSON.stringify({
          id_campaign: ccIds
        })).subscribe(result => {
          console.log(result)
          this.leadDialerList = []
          if (result.error == 0) {
            this.leadDialerList = result.data
          }
        }, error => {
          console.log("error::", error)
          this.leadDialerList = []
        })
      }
    }
  }

  onidclick(id: number, type: number,campId:any) {
    console.log("id & type",id ,type);
    
    if (type == 2)
      this.idclicktab.emit({ id: id, type: 1, aglead: true, campId });
    else
      this.idclicktab.emit({ id: id, type: type, aglead: false, campId });
  }

  assignLead() {
    console.log("freeleads", this.freeleads)
    const dialogRef = this.dialog.open(AssignleadComponent, {
      disableClose: true,
      width: 'auto',
      data: {
        leads: this.freeleads,
        type: 1
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      console.log(res);
      if (res != null && res != undefined) {
        this.data.updateAssignLead(JSON.stringify({
          formdata: res.fromdata.value,
          campaignsIds: res.campaignsIds,
          Dialers: res.Dialers
        })).subscribe(rs => {
          console.log(rs);
          this.openSnackBar(rs.message, "Clear");

          // @force reloading to get proper data
          setTimeout(() => {
            location.reload(true)
          }, 2000)
        });
      }
    });
  }

  reAssign(agid: number, agtlead: number) {
    console.log(agid, agtlead)
    console.log(this.setagent);
    const dialogRef = this.dialog.open(AssignleadComponent, {
      disableClose: true,
      width: 'auto',
      data: {leadss: agtlead,type: 2, fromagent: agid}
    });
    dialogRef.afterClosed().subscribe(res => {
      console.log(res);
      if (res != null || res != undefined)
       {
         
      this.data.ReAssignLeads(JSON.stringify({formdata:res.fromdata.value, fromagent:res.fromagent,campaignsIds:res.campaignsIds})).subscribe(rs=>{
            console.log(rs); 
            this.openSnackBar(rs.message,"Clear");
            this.data.gettotallead().subscribe(res=>{
              console.log(res);
              if(res!=null){
                this.freeleads=res[0].totallead;
                this.allleads=res[0].allleads;
              }
            });
        
            this.data.GetAgentLead().subscribe(result=>{
              console.log(result);
              this.agentlead=result;
            });
          });   

        // this.data.updateAssignLead(JSON.stringify({
        //   formdata: res.fromdata.value,
        //   fromagent: res.fromagent,
        //   campaignsIds: res.campaignsIds,
        //   Dialers: res.Dialers
        // })).subscribe(rs => {
        //   console.log(rs);
        //   // this.openSnackBar(rs.message, "Clear");
        // });
      }
    });

  }

  // onDelete() {
  //   const dialogRef = this.dialog.open(AlertComponent, {
  //     width: '700px',
  //     data: {
  //       name: {
  //         fullname: sessionStorage.getItem("fullname"),
  //         iduser: sessionStorage.getItem('userid')
  //       },
  //       leads: this.allleads,
  //       type: 2,
  //       batchfile: this.uploadlist
  //     }
  //   });
  //   dialogRef.afterClosed().subscribe(res => {
  //     console.log(res);
  //     if (res != null && res != undefined) {
  //       this.data.DeleteAllLeads(JSON.stringify(res)).subscribe(rss => {
  //         this.openSnackBar(rss.message, "Clear");
  //         this.data.gettotallead().subscribe(res => {
  //           console.log(res);
  //           if (res != null) {
  //             this.freeleads = res[0].totallead;
  //             this.allleads = res[0].allleads;
  //           }
  //         });

  //         // @reload the location
  //         location.reload(true)

  //         this.data.GetAgentLead().subscribe(result => {
  //           console.log(result);
  //           this.agentlead = result;
  //         });
  //       });
  //     }
  //   });
  // }

  // onRestoreLead() {
  //   this.data.getDeletedLeads().subscribe(res => {
  //     const dialogRef = this.dialog.open(RestoreleadsComponent, {
  //       width: 'auto',
  //       data: { data: res }
  //     });
  //     dialogRef.afterClosed().subscribe(result => {
  //       console.log(result);
  //       if (result != null && result != undefined) {
  //         this.data.RestoreINLeads(JSON.stringify({ leadid: result })).subscribe(rss => {
  //           this.openSnackBar("Leads Restored Successfully.", "Clear");
  //           this.data.gettotallead().subscribe(reslead => {
  //             console.log(reslead);
  //             if (reslead != null) {
  //               this.freeleads = reslead[0].totallead;
  //               this.allleads = reslead[0].allleads;
  //             }
  //           });

  //           // @reload the location
  //           location.reload(true)

  //           this.data.GetAgentLead().subscribe(resag => {
  //             console.log(resag);
  //             this.agentlead = resag;
  //           });
  //         });
  //       }
  //     });
  //   },
  //     err => {
  //       alert("No Leads found in your trace bin.");
  //     });
  // }

  SearchLeads() {
    this.data.SerachLeads(this.searchleads).subscribe(res => {
      console.log(res);
      this.idclicktab.emit({ id: -1, type: 5, sdata: res });
    });
  }

  get campIds(): any {
    if (sessionStorage.getItem("allcampaign")) {
      return JSON.parse(sessionStorage.getItem("allcampaign"))
    }
    return []
  }
  leadfilter(v:string){
    this.theme.leadsfilter(v);
    this.idclicktab.emit({total:10});
  }
}